import React from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import { Link } from "react-router-dom";
import { Switch } from "@mui/material";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";
import Avatar from "assets/images/Avatar.png";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";

function Author({ image, name, cityName, padding }) {
  return (
    <SoftBox display="flex" minWidth="300px" alignItems="center" px={padding} py={0.5}>
      {cityName ? (
        <SoftBox
          mr={2}
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            width: 36,
            height: 36,
            borderRadius: "100%",
            backgroundColor: "#E2E2E2",
            p: 0,
            flexShrink: 0,
          }}
        >
          <LocationCityOutlinedIcon sx={{ height: 20, width: 20, color: "#555F73" }} />
        </SoftBox>
      ) : (
        <SoftBox mr={2}>
          <SoftAvatar src={image} alt={name} size="sm" />
        </SoftBox>
      )}
      <Link>
        <SoftBox display="flex" flexDirection="column">
          <SoftTypography
            sx={{ fontSize: 14, color: "black.main", textTransform: "capitalize" }}
            fontWeight="normal"
          >
            {cityName ? cityName : name}
          </SoftTypography>
        </SoftBox>
      </Link>
    </SoftBox>
  );
}

export const columns = [
  { name: "user name", align: "left" },
  { name: "school/city", align: "left" },
  { name: "reported count", align: "left" },
  { name: "reason", align: "left" },
  { name: "action", align: "left" },
];

function Rows(data, setDialogue) {
  return {
    "reported count": (
      <SoftBox display="flex" alignItems="center" justifyContent="start">
        <SoftBox height="30px" />
        <SoftTypography
          sx={{ fontSize: 14, color: "black.main", textTransform: "capitalize" }}
          fontWeight="normal"
        >
          {data?.reported_count || 0}
        </SoftTypography>
      </SoftBox>
    ),

    "school/city": (
      <Author name={data?.school?.school_name} image={data?.school?.school_image} cityName={data?.school?.city} padding={0} />
    ),

    "user name": (
      <Author
        name={data?.user?.name}
        image={data?.user?.profile_pictures[0] || Avatar}
        padding={1}
      />
    ),

    reason: (
      <SoftBox minWidth="200px" display="flex" alignItems="center" justifyContent="start">
        <SoftBox height="30px" />
        <SoftTypography
          sx={{ fontSize: 14, color: "black.main", textTransform: "lowercase" }}
          fontWeight="normal"
        >
          {data?.reason}
        </SoftTypography>
      </SoftBox>
    ),

    status: (
      <SoftBox minWidth="150px">
        <Switch
          onClick={() =>
            setDialogue({
              type: "changeStatus",
              isOpen: true,
              action: "",
              schoolID: data?._id,
            })
          }
          checked={data?.is_active}
          color="secondary"
        />
        ,
      </SoftBox>
    ),

    action: !data?.user?.is_active ? (
      <SoftBox
         onClick={() =>
        setDialogue({
            type: "activateDeactivateUser",
            isOpen: true,
            action: "activate",
            userId: data?.user?._id,
          })
        }
        borderRadius="xxl"
        display="flex"
        sx={{
          backgroundColor: "green.light",
          width: "100%",
          py: 0.8,
          gap: 1,
          px: 1,
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        <PersonIcon sx={{ height: 20, width: 20, color: "green.main" }} />
        <SoftTypography
          fontWeight="normal"
          sx={{ color: "green.main", fontSize: 13, textTransform: "capitalize" }}
        >
          Activate user
        </SoftTypography>
      </SoftBox>
    ) : (
      <SoftBox
        onClick={() =>
            setDialogue({
            type: "activateDeactivateUser",
            isOpen: true,
            action: "deactivate",
            userId: data?.user?._id,
          })
        }
        borderRadius="xxl"
        display="flex"
        sx={{
          backgroundColor: "red.light",
          width: "100%",
          py: 0.8,
          gap: 1,
          px: 1,
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        <PersonOffIcon sx={{ height: 20, width: 20, color: "red.main" }} />
        <SoftTypography
          fontWeight="normal"
          sx={{ color: "red.main", fontSize: 13, textTransform: "capitalize" }}
        >
          Deactivate user
        </SoftTypography>
      </SoftBox>
    ),
  };
}

export default Rows;
